import { useNavigate } from "react-router-dom";
import Button from "../form/Button";

const NotFoundPage = ({ link = "/" }) => {
  const navigate = useNavigate();
  return (
    <div className="relative flex flex-col items-center justify-center h-[600px] text-center px-4 overflow-hidden">
      <svg
        className="absolute top-[-120px] left-[-150px] w-[500px] h-[500px] opacity-80 z-0"
        viewBox="0 0 600 600"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(300,300)">
          <path
            d="M150,-174.1C193.7,-132.3,219.5,-66.1,212.6,-8.3C205.7,49.5,166.1,99,122.4,140.4C78.7,181.8,30.9,215.1,-19.6,224.3C-70.1,233.5,-122.1,218.5,-154.1,180.2C-186,141.9,-197.8,80.4,-194.9,21.6C-192.1,-37.3,-174.7,-93.5,-138.8,-133.8C-102.8,-174.1,-51.4,-198.6,6.4,-205.7C64.2,-212.8,128.4,-202,150,-174.1Z"
            fill="#fca5a5"
          />
        </g>
      </svg>
      <svg
        className="absolute bottom-[-150px] right-[-150px] w-[400px] h-[400px] opacity-50 z-0"
        viewBox="0 0 600 600"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g transform="translate(300,300)">
          <path
            d="M123.4,-137.6C160.2,-92.7,191.1,-46.3,186.2,-3.4C181.2,39.4,140.5,78.8,103.8,127.8C67.1,176.7,33.6,235.1,-14.7,250.9C-63,266.6,-126,239.6,-158.2,189.5C-190.5,139.3,-192,66.1,-184.1,-3.2C-176.1,-72.6,-158.6,-139.2,-116.3,-180.4C-74.1,-221.6,-7.1,-237.5,44.4,-215.5C95.9,-193.5,131,-133.8,123.4,-137.6Z"
            fill="#fca5a5"
          />
        </g>
      </svg>

      <div className="relative z-10">
        <h1 className="text-[80px] font-extrabold text-rose-400 leading-none">
          404
        </h1>
        <h2 className="text-3xl font-light text-gray-900 mt-2">OOOps!</h2>
        <h3 className="text-2xl font-medium text-gray-800 mb-4">
          Page Not Found
        </h3>
        <p className="text-gray-500 max-w-md mb-6">
          This page doesn’t exist or was removed! <br />
          We suggest you back to home.
        </p>

        <div className="flex items-center justify-center relative">
          <Button
            buttonClasses={
              "!bg-rose-600 hover:!bg-rose-700 !text-white !font-medium !py-2 !px-6 !rounded-full !shadow-md !transition-all !w-[140px]"
            }
            buttonLabel={"Back"}
            buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
            buttonIcon={"fa-solid fa-hand-back-point-left"}
            buttonIconPosition="left"
            buttonFunction={() => navigate(link)}
          />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
